import { ListType } from 'modules/domains';
import { isValidEnumValue } from 'utils/tsHelpers';

import { useUpdateListType } from './useUpdateListType';
import { LIST_TYPE_MENU_OPTION_ID_PREFIX } from '../constants';

export const useHandleMenuOptionSelect = () => {
  const updateListType = useUpdateListType();

  return (selectedOptionId: string) => {
    if (selectedOptionId.startsWith(LIST_TYPE_MENU_OPTION_ID_PREFIX)) {
      const type = selectedOptionId.substring(LIST_TYPE_MENU_OPTION_ID_PREFIX.length);
      if (isValidEnumValue(type, ListType)) updateListType(type);
    }
  };
};
